import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

// Thunk to fetch advisors filter
export const getAdvisorsFilter = createAsyncThunk(
  "advisorsFilter/getAdvisorsFilter",
  async ({ clientId, accountType, search }, { rejectWithValue }) => {
    try {
      let query = `/api/advisorsFilter?`;
      if (clientId) query += `clientId=${clientId}&`;
      if (accountType) query += `accountType=${accountType}&`;
      if (search) query += `search=${encodeURIComponent(search)}&`;

      const response = await getMethod(query);
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch advisors filter");
    }
  }
);

const advisorsFilterSlice = createSlice({
  name: "advisorsFilter",
  initialState: {
    loading: false,
    fltradvisors: [],
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdvisorsFilter.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getAdvisorsFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.fltradvisors = action.payload?.data || [];
        state.success = true;
      })
      .addCase(getAdvisorsFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default advisorsFilterSlice.reducer;
